<div class="layout-wrapper" (click)="onLayoutClick()" rte="145">
    <div
        class="layout-container"
        [ngClass]="{
            'menu-layout-collapsed': isCollapsed,
            'menu-layout-collapsed-active': collapsedMenuActive,
            'menu-layout-horizontal': isHorizontal,
            'menu-layout-slim': isSlim,
            'layout-menu-static-inactive': staticMenuDesktopInactive,
            'layout-menu-static-active': staticMenuMobileActive,
            'p-ripple-disabled': !ripple,
            'p-input-filled': inputStyle === 'filled'
        }"
        rte="146">
        <ultima-topbar rte-hidden rte="147"></ultima-topbar>

        <div
            *ngIf="!isGenericPatient"
            [ngStyle]="{ display: shouldHideScrollPanel ? 'none' : 'block' }"
            class="layout-menu"
            [ngClass]="{ 'layout-menu-dark': darkMenu }"
            (click)="onMenuClick($event)"
            rte-hidden
            rte="148">
            <p-scrollPanel #layoutMenuScroller [style]="{ height: '100%', backgroundColor: '#000000', overflow: 'overlay' }" rte="149">
                <ultima-inline-profile *ngIf="profileMode === 'inline' && !isHorizontal" rte="14a"></ultima-inline-profile>
                <ultima-menu rte="14b"></ultima-menu>
            </p-scrollPanel>
        </div>

        <div class="layout-main" rte="14c">
            <incomplete-data-prompt></incomplete-data-prompt>

            <pending-matching-profiles-dialog></pending-matching-profiles-dialog>

            <incomplete-data-warning #incompleteData></incomplete-data-warning>

            <div class="layout-content" rte="14d" [style.padding-top]="incompleteData.height + 23 + 'px'">
                <maintenance-banner rte="14e"></maintenance-banner>

                <router-outlet></router-outlet>
            </div>
        </div>

        <ultima-footer rte-hidden rte="14g"></ultima-footer>

        <div class="layout-mask" rte="14h"></div>
    </div>
</div>

<after-login></after-login>
